import actions from '@/Core.Service.Domain/Sites/SiteSystems/Store/actions.ts';
import getters from '@/Core.Service.Domain/Sites/SiteSystems/Store/getters.ts';
import mutations from '@/Core.Service.Domain/Sites/SiteSystems/Store/mutations.ts';

import type { ISiteSystemsState } from '@/Core.Service.Domain/Sites/SiteSystems/types/index.ts';

const state: ISiteSystemsState = {
  siteSystems: [],
  siteSystem: null,
  siteSystemTypes: [],
  sitesForSelector: [],
  equipmentForSite: [],
  isSiteSystemsLoading: false,
  siteSystemSearchTerm: '',
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
